import { IModelEntity } from '@pit/core';
import { IDtoMandator } from './dto.mandator.interface';

export interface IDtoResourceUser extends IModelEntity {

    resourceCode?: string;
    resourceId?: string;
    userName?: string;
    userNumber?: string;
    timestampFrom?: Date;
    timestampTill?: Date;

}
